import { parseBootstrapPayload } from "../../dtos/uv-inserts/parse-bootstrap-payload"
import type { UvInsertsBootstrapPayload } from "models/uv-inserts"
import type { UVInsertConfig } from "../../models/uv-inserts"
import type { SuggestedMessaging } from "../../models/uv-inserts/suggested-messaging"
import type { TemplateIds } from "../../models/uv-inserts/template-ids"

export type ResolvedUvInserts = {
  configs: UVInsertConfig[]
  templateIds: TemplateIds
  suggestedMessaging: SuggestedMessaging
}

/**
 * Entry point for UV inserts: Liquid bootstrap payload to resolved models (DTO parsing inside).
 * UV inserts use Liquid-only data; no Storefront API.
 */
export function resolveUvInserts(options: {
  payload: UvInsertsBootstrapPayload
}): ResolvedUvInserts {
  return parseBootstrapPayload(options)
}
